export default __webpack_public_path__ + "static/media/0x695fc8b80f344411f34bdbcb4e621aa69ada384b.c6f32345.webp";